/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_ContextInputs */

const en_read_along_ai_context = /** @type {(inputs: Read_Along_Ai_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document context`)
};

const es_read_along_ai_context = /** @type {(inputs: Read_Along_Ai_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto del documento`)
};

/**
* | output |
* | --- |
* | "Document context" |
*
* @param {Read_Along_Ai_ContextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_context = /** @type {((inputs?: Read_Along_Ai_ContextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_ContextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_context(inputs)
	return en_read_along_ai_context(inputs)
});